import AnimalModItem from "../AnimalModItem";

const handler = ({log, translationManager, index}) => {
    const rawParams = log?.log?.Params?.[index ?? 0] ?? {};
    const params = log.getCodeParams(rawParams);

    const additionalInfo = log.log.AdditionalInfo ?? {};
    const isRFIDChange = additionalInfo._reason === "RFID_CHANGE";
    const rfidChange = additionalInfo._rfidChange;

    let title;
    let comment = log.getComment();
    let _rfidChangeAnimal = null;
    let changes = [];

    if (isRFIDChange && rfidChange) {
        title = translationManager.translate(
            "animalModList.deleteAnimalRFIDChange",
            params
        );
        comment = translationManager.translate(
            "animalModList.deleteAnimalRFIDChangeComment"
        );
        _rfidChangeAnimal = rfidChange.animal;
        changes = [
            {
                name: "RFID",
                oldValue: rfidChange.oldRFID,
                newValue: rfidChange.newRFID,
                path: "RFID",
            },
        ];
    } else {
        title = translationManager.translate(`$t(logsView.codes.2057)`, params);
    }

    return new AnimalModItem({
        invokedBy: log.getUserObj(),
        timestamp: log.log.DtaCrtTime,
        animalId: log.log.ObjID,
        comment,
        changes,
        title,
        _rfidChangeAnimal,
        id: log.log.LogID,
        objectId: log.log.ObjOld?.EvID,
        subgroupName: translationManager.format(
            "subgroupNameFormatter",
            log.log.ObjID
        ),
    });
};

handler.RegExp = new RegExp(`^2057$`, "g");

export default handler;
